import React, { useState } from "react";


export default function Services() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // toggle
  };

  return (
    <div className="inner_content">
      <h2>what I can do for you</h2>
      <p>
        As a Full Stack Developer, I build end-to-end digital solutions that
        blend intuitive design with robust functionality—bringing ideas to life
        through clean code and creative thinking.
      </p>
      <ul>
        {[
          {
            title: "1. UI/UX Design",
            items: [
              "Wireframing and prototyping",
              "User Interface design for web and mobile apps",
              "Usability testing and user feedback analysis",
              "Interaction design and micro-animations",
            ],
          },
          {
            title: "2. Web Development",
            items: [
              "Responsive Websites",
              "Custom Web Applications",
              "API Integrations",
              "Performance Optimization",
            ],
          },
          {
            title: "3. Data Analysis",
            items: [
              "Data Cleaning",
              "Exploratory Data Analysis",
              "Visualization Dashboards",
              "Predictive Modeling",
            ],
          },
          {
            title: "4. Artificial Intelligence",
            items: [
              "ML Model Training",
              "Chatbots & NLP",
              "Image Recognition",
              "AI-powered Recommendations",
            ],
          },
        ].map((service, index) => (
          <li
            key={index}
            className={activeIndex === index ? "active" : ""}
          >
            <h2 onClick={() => handleClick(index)}>{service.title}</h2>
            <div className="content">
              <ul>
                {service.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
